export function capitalize(s) {
  return (s && String(s[0]).toUpperCase() + String(s).slice(1)) || "";
}

export function formatPrice(n) {
  return Number(n).toLocaleString("ru-RU") + " ₽";
}

export function formatQuantity(n) {
  return Number(n).toLocaleString("ru-RU") + " шт.";
}
